import { InfoCircleOutlined } from "@ant-design/icons";
import { Table, Tag, Pagination, Popover } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPluralString } from "../../helpers/wordHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function UnitsTable(props) {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  let navigate = useNavigate();
  const pageLimit = 40;

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  /*If page changed from parent component */
  useEffect(() => {
    setPage(props.page);
  }, [props.page]);

  const columns = [
    {
      title: "Unit name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Level",
      key: "level",
      dataIndex: "level",
      sorter: (a, b) => a.organizationLevel?.order - b.organizationLevel?.order,
      render: (text, record) => (
        <Tag color={record?.organizationLevel?.color}>
          {record?.organizationLevel?.name?.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Head unit",
      dataIndex: "headUnit",
      key: "headUnit",
      render: (text, record) => (
        <>
          {record.headUnit?.name ? (
            <div className="flex items-center">
              <div
                className="w-2 h-2 mr-1 rounded-full"
                style={{ backgroundColor: record.headUnit?.level?.color }}
              />
              <div>{record.headUnit?.name}</div>
              <Popover
                placement="top"
                content={
                  <div className="text-xs">
                    {record.name + " < " + record.headUnit?.name}
                    {record.headUnit?.headUnit &&
                      " < " + record.headUnit?.headUnit?.name}
                  </div>
                }
                trigger="hover"
              >
                <div className="text-gray-500 text-xs ml-1">
                  <InfoCircleOutlined />
                </div>
              </Popover>
            </div>
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      title: getPluralString(topPlanState),
      dataIndex: "objectives",
      key: "objectives",
    },
    {
      title: "Performance",
      dataIndex: "performance",
      key: "performance",
      render: (text, record) => (
        <Tag
          color={
            record.status === "off"
              ? "Orange"
              : record.status === "risk"
              ? "Red"
              : "Green"
          }
        >
          {text + "%" || "0%"}
        </Tag>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={props.data?.units}
        pagination={false}
        loading={loading}
        onRow={(record) => {
          return {
            onClick: () => {
              navigate(`/units/${record.id}`);
            },
          };
        }}
        rowClassName={"cursor-pointer hover:shadow"}
      />
      <div className="text-center mt-6">
        <Pagination
          onChange={(num) => props.changePage(num)}
          current={page}
          total={props.data?.totalCount || 0}
          pageSize={pageLimit}
        />
      </div>
    </>
  );
}

export default UnitsTable;
